import Upload from "../../components/uploadImage/Upload";
import Tips from "../../components/tips/Tips";
import "./main.css";
import Footer from "../../components/footer/Footer";

const MainPage = () => {
  return (
    <div style={{ backgroundColor: "#F5F5F5", color: "#262626" }}>
      <div className="main-page-root">
        <h1>Canada Goose Authenticator</h1>
        <h4 className="main-page-subtitle1">
          Upload your jacket's badge to check if your Canada Goose product is
          real.
        </h4>
        <h4 className="main-page-subtitle2">Powered By SARC Technologies</h4>
      </div>
      <div className="flex-center">
        <Upload />
      </div>
      <div className="flex-center">
        <Tips />
      </div>
      <div>
        <Footer />
      </div>
    </div>
  );
};

export default MainPage;
